// extracted by mini-css-extract-plugin
module.exports = {"input":"style_input__3sdSB","form":"style_form__2WUGV"};